<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',
  components: {
  },
  data() {
    return {}
  },
  computed: {
    modal() {
      return this.$store.getters.modal
    }
  },
  watch: {
    modal: {
      deep: true,
      handler() {
        let isVisibleModal = false
        for (const property in this.modal) {
          if (this.modal[property]) {
            isVisibleModal = true
            break
          }
        }
        if (isVisibleModal) {
          document.documentElement.style.overflow = 'hidden'
        } else {
          document.documentElement.style.overflow = 'visible'
        }
      }
    }
  },
  mounted() {
    console.log(process.env)
  },
  methods: {
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
}
</style>